(function () {
  'use strict';

  if (window.__GS_WISHLIST_NO_FLASH_V14__) return;
  window.__GS_WISHLIST_NO_FLASH_V14__ = true;

  var root = document.documentElement;
  var gridSelector = '.wishlist-storefront-page__grid';
  var cardSelector = '.wishlist-storefront-page__card';
  var titleSelector = '.wishlist-storefront-page__card-title';
  var imageSelector = '.wishlist-storefront-page__card-image img, .wishlist-storefront-page__card-placeholder img, img.gs-wishlist-restored-image';
  var placeholderSelector = '.wishlist-storefront-page__card-placeholder';
  var startedAt = Number(window.__GS_WISHLIST_HYDRATION_STARTED_AT__ || Date.now());
  var released = false;
  var scanQueued = false;
  var observer = null;

  function text(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function isRawHandle(value) {
    return /^[a-z0-9]+(?:-[a-z0-9]+)+$/i.test(text(value));
  }

  function finishHydration() {
    if (released) return;
    released = true;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.remove('gs-wishlist-hydrating', 'gs-wishlist-error');
        root.classList.add('gs-wishlist-ready');
        if (observer) observer.disconnect();
      });
    });
  }

  function imageIsPrepared(card) {
    var placeholder = card.querySelector(placeholderSelector);
    if (placeholder && /no\s*image/i.test(text(placeholder.textContent))) return false;

    var image = card.querySelector(imageSelector);
    if (!image) return false;

    return Boolean(text(image.getAttribute('src') || image.currentSrc));
  }

  function cardIsVisuallyReady(card) {
    if (!(card instanceof Element)) return false;

    var title = card.querySelector(titleSelector);
    var titleText = text(title && title.textContent);
    if (!titleText || isRawHandle(titleText)) return false;

    return imageIsPrepared(card);
  }

  function evaluate() {
    if (released) return;

    var elapsed = Date.now() - startedAt;
    var grid = document.querySelector(gridSelector);

    if (!grid) {
      if (elapsed >= 2500) finishHydration();
      return;
    }

    var cards = Array.from(grid.querySelectorAll(cardSelector));

    if (!cards.length) {
      if (elapsed >= 2000) finishHydration();
      return;
    }

    if (cards.every(cardIsVisuallyReady) || elapsed >= 6000) {
      finishHydration();
    }
  }

  function queueEvaluate() {
    if (released || scanQueued) return;
    scanQueued = true;

    window.requestAnimationFrame(function () {
      scanQueued = false;
      evaluate();
    });
  }

  function start() {
    root.classList.add('gs-wishlist-hydrating');
    root.classList.remove('gs-wishlist-ready', 'gs-wishlist-error');

    evaluate();

    [100, 250, 500, 800, 1200, 1800, 2600, 3600, 4800, 6000].forEach(function (delay) {
      window.setTimeout(evaluate, delay);
    });

    document.addEventListener('shopify:section:load', queueEvaluate);

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(queueEvaluate);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }

    window.setTimeout(finishHydration, 6500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
